import { combineReducers } from "redux";
import { userToken, EnquiryPopup } from "./user";

const rootReducer = combineReducers({
  userToken,
  EnquiryPopup,
});
export default rootReducer;
